/**
 * The authenticator entry's name (crmarr/templates auth-self-hosted-sign-in.md R14): an authenticator app shows the
 * issuer bold and the account beneath it, so the issuer is the host the portal runs on (portal.dev.starsach.com on
 * dev) - never the auth domain - and the account is the person's email, never the Cognito username (a UUID). The
 * label's host and the `issuer` parameter are identical and percent-encoded, `+` in an address as `%2B`, since
 * authenticator apps fall back to one or the other. Every enrollment path builds its URI here.
 */
export function otpauthUri(host: string, email: string, secret: string): string {
  const account = email.trim();
  if (!account) throw new Error("An authenticator entry needs the person's email");
  const issuer = encodeURIComponent(host);
  return `otpauth://totp/${issuer}:${encodeURIComponent(account)}?secret=${encodeURIComponent(secret)}&issuer=${issuer}`;
}

/** The host the portal is served from: the authenticator entry's issuer. */
export function portalHost(): string {
  return window.location.host;
}
